import * as React from 'react'
import { FC, useCallback } from 'react'
import { HereResult } from '@user/store/services/hereGeoCoder'
import ListItem from '@mui/material/ListItem'

interface Props {
  onSelectPlace: (place: HereResult) => void
  place: HereResult
}

export const PlaceListItem: FC<Props> = (props) => {
  const { place, onSelectPlace } = props

  const onClick = useCallback(
    () => onSelectPlace(place),
    [onSelectPlace, place],
  )

  return (
    <ListItem button onClick={onClick}>
      {place.address.label}
    </ListItem>
  )
}
PlaceListItem.displayName = 'PlaceListItem'
